import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import styles from "../../styles/pages/feed/FeedPage.module.css";

const FeedTabErrorState = ({ title, message, onRetry }) => (
  <div className={styles.emptyState} role="alert">
    <FaExclamationTriangle className={styles.emptyIcon} aria-hidden="true" />
    <h2>{title}</h2>
    <p>{message}</p>
    <div className={styles.emptyActions}>
      <button type="button" className={styles.exploreButton} onClick={onRetry}>
        Try again
      </button>
    </div>
  </div>
);

export default React.memo(FeedTabErrorState);
